<template>
  <div>
    <div class="app-head">
      <div>
        <h4 class="app-title">学习学生信息</h4>
        <div class="app-desc">显示已学习的学生信息。</div>
      </div>
      <div>
        <router-link to="/course-study">返回学习统计</router-link>
      </div>
    </div>
    <div class="app-form">
      <div class="course">
        <el-alert v-if="!list.length" type="error" :closable="false">~还没有学习学生</el-alert>
        <el-table
          v-else
          highlight-current-row
          border
          :data="list"
          v-loading="listLoading"
          height="100%"
          style="width: 100%">
          <el-table-column
            fixed
            type="index">
          </el-table-column>
          <el-table-column
            prop="name"
            label="学生"
            width="80">
            <template v-slot="{row}">
              {{ row.name }}
            </template>
          </el-table-column>
          <el-table-column
            prop="sex"
            label="性别"
            width="50">
            <template v-slot="{row}">
              <span>{{ showSex(row.sex) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="coursename"
            label="学习资源" />
          <el-table-column
            prop="intime"
            label="最近学习时间">
            <template v-slot="{row}">
              <time>{{ row.intime }}</time>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="120">
            <template v-slot="{row}">
              <!-- <JyButton v-if="hasPermiss('weborg.employee.edit')" type="primary" size="sm" class="mr-2" @click="doEdit(scope.row)">编辑</JyButton> -->
              <JyButton v-if="hasPermiss('weborg.employee.del')" type="danger" size="sm" @click="doDel(scope.row)">移除</JyButton>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="course-pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import * as types from '@/store/mutation-types';
import { mapGetters } from 'vuex';
import tools from '@/utils/tools';
export default {
  mixins: [tools],
  components: {  },
  data () {
    return {
      loading: false,
      page: 1,
      total: 0,
      listLoading: false,
      list: [{
        name: '李四',
        sex: false,
        coursename: '课程名称1',
        intime: '2019-11-30 11:05:45'
      }],
    }
  },
  computed: {
    ...mapGetters({
    }),
  },
  watch: {
  },
  created () {
  },
  mounted() {
  },
  activated () {
    if (!this.list.length) {
      this.loadData();
    }
  },
  methods: {
    loadData() {
      if (this.loading || !this.hasPermiss('weborg.coursestu.query')) {
        return;
      }
      this.loading = true;
      this.doPost({
        url: 'vue/organization/course/stu',
        data: Object.assign({page: this.page}, this.searchData),
        okcb: (json) => {
          this.list = json.list;
          this.page = json.pageNumber;
        },
        cb: () => {
          this.$nextTick(() => this.loading = false);
        }
      });
    },
    showContent(data) {
      let content = data.content;
      if (content) {
        content = content.replace(/<\/?.+?\/?>/g, '');
      }
      return content;
    },
    doEdit(data) {
      this.$router.push('/course-edit/'+ data.id);
    },
    doDel(data) {
      this.msgbox('确定要删除该图文吗？', () => {
        this.doPost({
          url: 'vue/organization/course/del/'+ data.id,
          okcb: () => {
            this.$message.success('删除成功！');
            this.list.splice(this.list.indexOf(data), 1);
          },
          cb: () => {
  
          }
        });
      });
    }
  }
}
</script>
<style lang="less" scoped>
.app {
  &-head {
    margin-bottom:2rem;
    .flex();
    justify-content:space-between;
  }
  &-title {
    font-size:2rem;
  }
  &-desc {
    color:#555;
  }
}
.course {
  &-pagination {
    margin-top:2rem;
    .flex-center();
  }
}
</style>